<nav class="navbar navbar-light bg-white border-top mt-5">
  <div class="navbar-expand m-auto navbar-text">
    Made with <i class="fa fa-heart"></i> by <a href="https://www.copas.nl">Copas</a>
  </div>
</nav>
